import { render } from "./RepositoryPopup.vue?vue&type=template&id=866009ba&scoped=true&ts=true"
import script from "./RepositoryPopup.vue?vue&type=script&lang=ts"
export * from "./RepositoryPopup.vue?vue&type=script&lang=ts"

import "./RepositoryPopup.vue?vue&type=style&index=0&id=866009ba&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866009ba"]])

export default __exports__